var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCamp = function SvgCamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#789D4A",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.664 28.333h16.667m-1.683.009V25M12.5 21.666h10m-5 6.667v-3.125m5.008 3.117-10 .017-.008-12.45c0-.559.283-1.075.742-1.384l3.333-2.225a1.66 1.66 0 0 1 1.85 0l3.333 2.225c.467.309.742.825.742 1.384zM26.666 20c-.917 0-1.667.75-1.667 1.666v1.667c0 .917.75 1.667 1.667 1.667.916 0 1.666-.75 1.666-1.667v-1.666c0-.917-.75-1.667-1.666-1.667Zm-7.917-2.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
  })));
};
export default SvgCamp;